export default class LazyString {
  fn: () => { toString(): string };

  constructor(fn: () => { toString(): string }) {
    this.fn = fn;
  }

  toString() {
    return this.fn().toString();
  }
}
